/*
 * @Author: manuelzhao manuelzhao@tencent.com
 * @Date: 2022-12-09 10:16:55
 * @LastEditors: manuelzhao manuelzhao@tencent.com
 * @LastEditTime: 2023-09-15 18:13:31
 * @FilePath: /wemeet-web-activity/src/components/HomeHeader/FollowGuide/guideMobile.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { memo } from 'react';
import { Drawer } from '@tencent/calendar-web-component-mobile';
import style from './index.module.scss';
import Link from 'next/link';
import Button from '@tencent/tpm-meeting-active/lib/Button';
import { LazyLoadImage } from 'react-lazy-load-image-component';

interface GuideMobileProps {
  visible: boolean;
  onClose?: VoidFunction;
  handleKnowBtn?: VoidFunction;
  handleNoRemind?: VoidFunction;
}

const GuideMobile = ({ visible, onClose, handleKnowBtn, handleNoRemind }: GuideMobileProps) => (
  <Drawer title={null} visible={visible} className={style['mobile-guide-drawer']} onClose={onClose}>
    <div className={style['title-1']}>查看已关注的主办方及其动态</div>
    <div className={style['title-2']}>
      您可以在 &quot;我的 - <Link href="/index">活动空间&quot; </Link>中查看关注的主办方及最新动态,
      客户端需要更新至3.8及以上版本
    </div>
    <div className={style['gif-img']}>
      <LazyLoadImage
        src="https://cdn.calendar.tencent.com/calendar_res/activity/follow_guide_m.gif"
        className={style.gif}
        loading="lazy"
      />
    </div>
    <Button onClick={handleKnowBtn} type="primary">
      知道了
    </Button>
    <Button onClick={handleNoRemind} className={style['second-btn']}>
      不再提醒
    </Button>
  </Drawer>
);

export default memo(GuideMobile);
